import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  TextField,
  DialogActions,
  DialogContent,
  Box,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import styles from "./NewObjectiveDialog.module.scss";
import { useState } from "react";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useTranslation } from "react-i18next";
import DropdownSelect from "../../../../components/dropdown-select/DropdownSelect";
import { ObjectiveType } from "../../../../state/constants/ObjectiveConstants";

export function NewObjectiveDialog(props) {
  const { dialogTitle, confirmLabel, onCancel, onConfirm, isOpen } = props;
  const [t, i18n] = useTranslation()

  const [objectiveType, setObjectiveType] = useState(ObjectiveType().admin.key)
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [dueTime, setDueDate] = useState(null);
  const [expirationDate, setExpirationDate] = useState(null);
  const [completeInCall, setCompleteInCall] = useState(true);
  const [subType, setSubType] = useState("Admin");

  function handleConfirm() {
    onConfirm({
      title,
      description,
      dueTime,
      expirationDate,
      completeInCall,
      subType,
      objectiveType
    });

    clearFields();
  }

  function clearFields() {
    setTitle("");
    setDescription("");
    setDueDate(null);
    setExpirationDate(null);
    setCompleteInCall(true);
    setSubType("Admin");
    setObjectiveType(ObjectiveType().admin.key)
  }

  function handleCancel() {
    onCancel();
  }

  return (
    <Dialog
      fullWidth={true}
      open={isOpen}
      aria-labelledby="scroll-dialog-title"
    >
      <DialogTitle id="scroll-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        <DropdownSelect
          label={t("objective.objective-type")}
          handleChange={(value) => {
            setObjectiveType(value)
            setCompleteInCall(value.key == ObjectiveType().admin_route.key)
          }}
          data={Object.values(ObjectiveType())}
          value={objectiveType}
          className={styles.textField}
          compulsory
        />
        <TextField
          label={t('common.title')}
          value={title}
          onChange={(event) => {
            setTitle(event.target.value);
          }}
          margin="dense"
          variant="outlined"
          className={styles.textField}
        />
        <TextField
          label={t('common.description')}
          value={description}
          onChange={(event) => {
            setDescription(event.target.value);
          }}
          margin="dense"
          variant="outlined"
          className={styles.textField}
        />
        <TextField
          label="Sub Type"
          value={subType}
          onChange={(event) => {
            setSubType(event.target.value);
          }}
          margin="dense"
          variant="outlined"
          className={styles.textField}
        />
        <Box>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className={styles.textField}
              label={t('objective.select-due-date')}
              margin="dense"
              disableToolbar
              disablePast={true}
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              helperText={""}
              value={dueTime}
              onChange={(date) => {
                setDueDate(date);
              }}
            />
          </MuiPickersUtilsProvider>
        </Box>

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            className={styles.textField}
            label={t('objective.select-expiration-date')}
            margin="dense"
            disablePast={true}
            disableToolbar
            variant="inline"
            inputVariant="outlined"
            format="dd/MM/yyyy"
            helperText={""}
            value={expirationDate}
            onChange={(date) => {
              setExpirationDate(date);
            }}
          />
        </MuiPickersUtilsProvider>
        {
          objectiveType == ObjectiveType().admin_route.key ?
            null :
            <FormControlLabel
              label={t('objective.must-complete-in-call')}
              control={
                <Checkbox
                  onChange={(event) => {
                    setCompleteInCall(event.target.checked);
                  }}
                  checked={completeInCall}
                  name="CompleteInCall" />
              }
            />
        }

      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleCancel()} color="secondary">
          {t('common.cancel')}
        </Button>
        <Button onClick={() => handleConfirm()} color="secondary">
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
